import React, { Fragment, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  login,
  logout,
  addMfaDevice,
  validateUserRole,
} from "../../action/auth";
import { getTenantInfo } from "../../action/tenant";
import Alert from "../layout/Alert";
import UseForm from "./UseForm";
import validate from "./LoginFormValidationRules";
import ReCAPTCHA from "react-google-recaptcha";
import customConfig from "../../config";
import CircularProgress from "@material-ui/core/CircularProgress";
import env from "../../env";
import MfaQRcode from "./mfaQRcode";
import MfaValidate from "./mfaValidationCode";
import ForgotPassword from "./forgotPassword";
// Removed lucide-react due to using material icons
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";


// const CLIENT_ID = env.GET_CLIENT_ID();
const SCOPE = process.env.REACT_APP_SCOPE;

const Login = ({
  login,
  isAuthenticated,
  logout,
  getTenantInfo,
  addMfaDevice,
  qrCodeUrl,
  mfaToken,
  validateUserRole,
}) => {
  const captchaRef = React.useRef(null);
  const isMountedRef = React.useRef(true);
  const [recaptchaValue, setRecaptchaValue] = useState();
  const [showError, setShowError] = useState(false);
  const { handleSubmit, InputOnFocus, handleChange, values, errors } = UseForm(
    loginForm,
    validate,
  );

  const [isLoading, setIsLoading] = useState(false);
  const [tenantData, setTenantData] = useState({});
  const [tmsAPIError, setTmsAPIError] = useState(false);
  const [showQrCode, setShowQrCode] = useState(false);
  const [mfavalidationCode, setMfaValidationCode] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  useEffect(() => {
    setIsLoading(true);
    getTenantInfo()
      .then((res) => {
        setIsLoading(false);
        setTenantData(res);
        localStorage.setItem("tenantInfo", JSON.stringify(res));
      })
      .catch((err) => {
        setIsLoading(false);
        setTmsAPIError(true);
      });
  }, [getTenantInfo]);

  useEffect(() => {
    if (qrCodeUrl) {
      setShowQrCode(true);
    }
    if (mfaToken) {
      setMfaValidationCode(true);
    }
  }, [qrCodeUrl, mfaToken]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  async function loginForm() {
    if (!recaptchaValue) {
      setShowError(true);
      return;
    }

    try {
      const res = await login(
        values.mobile,
        values.password,
        env.GET_CLIENT_ID(),
        SCOPE,
        recaptchaValue,
      );
      if (res?.data?.accessToken) {
        validateUserRole(res);
        return; // do not reset
      }
    } catch (err) {
    } finally {
      if (isMountedRef.current && captchaRef.current) {
        setRecaptchaValue("");
        captchaRef.current?.reset();
      }
      // resetCaptcha(); // reset only after login finishes
    }
  }
  // const resetCaptcha = () => {
  //   captchaRef.current?.reset();
  //   setRecaptchaValue("");
  // };

  const onChangeRecaptcha = (value) => {
    setRecaptchaValue(value);
    setShowError(false);
  };

  const errorCallback = () => {
    setRecaptchaValue("");
    setShowError(true);

    if (captchaRef.current) {
      captchaRef.current.reset();
    }
  };

  const onExpiredCallback = () => {
    setRecaptchaValue("");
    setShowError(true);

    if (captchaRef.current) {
      captchaRef.current.reset();
    }
  };

  if (isAuthenticated) {
    // if(mfaToken === null){
    //   alert(customConfig.mfaEnableMsg);
    // }
    
    return <Redirect to="/landing" />;
  }

  if (showQrCode && qrCodeUrl) {
    return (
      <div style={{ display: "grid", placeItems: "center", height: "100vh" }}>
        <MfaQRcode tenantData={tenantData} />
      </div>
    );
  }

  if (mfaToken && mfavalidationCode) {
    return (
      <div style={{ display: "grid", placeItems: "center", height: "100vh" }}>
        <MfaValidate tenantData={tenantData} />
      </div>
    );
  }
  if (isLoading) {
    return (
      <div className="login-wrapper">
        <div className="login-box">
          <div
            style={{
              display: "grid",
              placeItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
          </div>
        </div>
      </div>
    );
  }
  if (tmsAPIError) {
    return (
      <div
        style={{
          background: "#f0f0f0",
          display: "grid",
          placeItems: "center",
          width: "100%",
          textAlign: "center",
          paddingTop: "10vh",
        }}
      >
        <div
          style={{
            width: "80%",
            height: "80vh",
            display: "grid",
            placeItems: "center",
            background: "#fcfcfc",
          }}
        >
          <div style={{ paddingBottom: 0 }}>
            <p
              style={{
                fontWeight: "bold",
                color: "#B8B8B8",
              }}
            >
              <span style={{ fontSize: 100, color: "grey" }}>500 </span>
              <span style={{ fontSize: 60, color: "#bd2d19" }}>
                Server Error
              </span>
            </p>
          </div>
          <div
            style={{
              fontSize: 25,
              textAlign: "left",
            }}
          >
            <p>Oops, something went wrong.</p>
            <br></br>
            <p>
              Try to refresh this page or feel free to contact us if the problem
              persists
            </p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <Fragment>
      <div className="login-wrapper">
        <div className="login-box">
          <div className="form-box">
            <div className="row mb-0">
              <Alert />
              <div className="col s12 center-align">
                <img
                  src={tenantData.tenantLogoUrl}
                  alt="Logo"
                  className="logo-outer"
                  // style={{ width: "250px", height: "55px" }}
                />
              </div>
            </div>
            <form className="form" onSubmit={handleSubmit} noValidate>
              <div className="row">
                <div className="input-field p-0 col s12">
                  <label htmlFor="mobile">User Name</label>
                  <input
                    type="text"
                    name="mobile"
                    autoComplete="off"
                    value={values.mobile || ""}
                    onChange={handleChange}
                    onInput={InputOnFocus}
                    required
                    placeholder="Enter User Name"
                    className={`add-input xl ${errors.mobile && "is-danger"}`}
                  />
                  {errors.mobile && (
                    <p
                      className="help is-danger error-message "
                      style={{ marginTop: "10px" }}
                    >
                      {errors.mobile}
                    </p>
                  )}
                </div>
              </div>
              <div className="row mb-0">
                <div className="input-field p-0 col s12">
                  <label htmlFor="password">Password</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={values.password || ""}
                      onChange={handleChange}
                      onInput={InputOnFocus}
                      minLength="6"
                      placeholder="Enter Password"
                      className={`add-input xl ${errors.password && "is-danger"}`}
                      required
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#888",
                      }}
                      aria-label="Toggle password visibility"
                    >
                      {showPassword ? (
                        <VisibilityOffIcon size={20} />
                      ) : (
                        <VisibilityIcon size={20} />
                      )}
                    </span>
                  </div>
                  {errors.password && (
                    <p className="help is-danger error-message">
                      {errors.password}
                    </p>
                  )}
                </div>
              </div>
              {/* Will integrate reset password journey later */}
              <div className="row mb-0">
                <div
                  style={{
                    textAlign: "left",
                    padding: "3px",
                    fontSize: "12px",
                    color: "#6f6f6f",
                    marginBottom: "5px",
                  }}
                >
                  <span>
                    Forgot Password? Click to{" "}
                    <a
                      href="#"
                      style={{
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setForgotOpen(true);
                      }}
                    >
                      reset
                    </a>
                    .
                  </span>
                </div>
              </div>
              <div className="capcha-box">
                <ReCAPTCHA
                  ref={captchaRef}
                  sitekey={process.env.REACT_APP_CAPTCHA_API_KEY}
                  onChange={onChangeRecaptcha}
                  onErrored={errorCallback}
                  onExpired={onExpiredCallback}
                />
                {showError && (
                  <p
                    className="help is-danger error-message "
                    style={{ marginTop: "10px" }}
                  >
                    {customConfig.captchaErrorMsg}
                  </p>
                )}
              </div>

              <div className="row mb-0">
                <div className="input-field p-0 col s12">
                  <button
                    className="btn add-btn xl col s12  mTop20"
                    type="submit"
                    name="action"
                  >
                    Sign In{" "}
                  </button>
                </div>
              </div>
            </form>
          </div>

          {/* <div className="white-text center font-13">
            Copyright © 2020 Panasonic India Pvt Ltd.
          </div> */}
        </div>
        {/* <div className="footer login font-13  font-300i">
          Designed and Developed by Panasonic India Innovation Center
        </div>{" "} */}
        <ForgotPassword
          open={forgotOpen}
          onClose={() => setForgotOpen(false)}
        />
      </div>
    </Fragment>
  );
};
Login.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  qrCodeUrl: PropTypes.string,
  addMfaDevice: PropTypes.func.isRequired,
  mfaToken: PropTypes.string,
  validateUserRole: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  qrCodeUrl: state.auth.qrCodeUrl,
  mfaToken: state.auth.mfaToken,
});

const mapDispatchToProps = (dispatch) => {
  return {
    login: login(dispatch),
    logout: logout(dispatch),
    getTenantInfo: getTenantInfo(dispatch),
    addMfaDevice: (accessToken) => dispatch(addMfaDevice(accessToken)),
    validateUserRole: (res) => dispatch(validateUserRole(res)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
